export default __webpack_public_path__ + "static/media/uz.7a31f1e5.svg";